import { PageRouteConfig } from '@/modules/core/app/helpers/PageRouteConfig';
import { Module } from '@/modules/core/app/constants/app.constants';

export const router = PageRouteConfig.factory(
  {
    path: '/cancellationreasons',
    name: 'cancellationreasons',
    component: () =>
      import(
        /* webpackChunkName: "cancellation-reason-page" */ './pages/CancellationReasonPage.vue'
      ),
  },
  Module.CANCELLATIONREASON
);
